export enum AssetCategoryAccount {
  INCOME = 'income account',
  EXPENSE = 'expense account',
}

export enum AssetAccountTag {
  CATEGORY = 'Category',
  SUBCATEGORY = 'Subcategory',
}
